import { Box, Link, Typography, styled } from "@material-ui/core";
import * as React from "react";

import cover from "../../images/cover.jpg";
import { logEvent } from "../../utils/Analytics";

export interface BuyLink {
  paper: string;
  kindle: string;
}

const BUY_LINK_US: BuyLink = {
  paper: "https://amzn.to/3s0vrAW",
  kindle: "https://a.co/d/iHYjXbX",
};

const BUY_LINK_US_GOOG: BuyLink = {
  paper:
    "https://www.amazon.com/dp/1914933672?maas=maas_adg_A2A1A457C5455F72FEB44EAB57721BD5_afap_abs&ref_=aa_maas&tag=maas",
  kindle:
    "https://www.amazon.com/dp/B0CP4H35NJ?maas=maas_adg_A2A1A457C5455F72FEB44EAB57721BD5_afap_abs&ref_=aa_maas&tag=maas",
};

const BUY_LINK_US_FB: BuyLink = {
  paper:
    "https://www.amazon.com/dp/1914933672?maas=maas_adg_31DDC8ADE128742CE9F04554AB27E340_afap_abs&ref_=aa_maas&tag=maas",
  kindle:
    "https://www.amazon.com/dp/B0CP4H35NJ?maas=maas_adg_31DDC8ADE128742CE9F04554AB27E340_afap_abs&ref_=aa_maas&tag=maas",
};

const BUY_LINK_IN: BuyLink = {
  paper: "https://amzn.eu/d/e39OeNj",
  kindle: "https://amzn.eu/d/7nYay7v",
};

const BUY_LINK_UK: BuyLink = {
  paper: "https://amzn.eu/d/9e4e8YX",
  kindle: "https://amzn.eu/d/8dcAvl7",
};

const BUY_LINK_AU: BuyLink = {
  paper: "https://amzn.asia/d/eeY59wG",
  kindle: "https://amzn.asia/d/eeY59wG",
};

const BUY_LINK_DE: BuyLink = {
  paper: "https://amzn.eu/d/9j98e8n",
  kindle: "https://amzn.eu/d/2oWX0NU",
};

export const SAMPLE_LINK =
  "https://firebasestorage.googleapis.com/v0/b/scaevola-marketing.appspot.com/o/THE_SCAEVOLA_CONSPIRACY_SAMPLE.pdf?alt=media&token=4bd3a2a1-bb63-4e64-9773-221931a860c6";

import amazon from "../../images/amazon.png";
import amazon_dark from "../../images/amazon_dark.png";

const AmazonImage = styled("img")(({ theme }) => ({
  width: "250",
}));

const Image = styled("img")(({ theme }) => ({
  width: "90%",
  borderRadius: 8,
  [theme.breakpoints.up("xs")]: {
    width: "90%",
  },
  [theme.breakpoints.up("sm")]: {
    width: 220,
  },
  [theme.breakpoints.up("md")]: {
    width: 330,
  },
  [theme.breakpoints.up("lg")]: {
    width: 440,
  },
}));

export const getBuyLink = (lang: string | undefined | null): BuyLink => {
  if (lang === "in") {
    return BUY_LINK_IN;
  } else if (lang === "us") {
    return BUY_LINK_US;
  } else if (lang === "us_goog") {
    return BUY_LINK_US_GOOG;
  } else if (lang === "us_fb") {
    return BUY_LINK_US_FB;
  } else if (lang === "uk") {
    return BUY_LINK_UK;
  } else if (lang === "au") {
    return BUY_LINK_AU;
  } else if (lang === "de") {
    return BUY_LINK_DE;
  }
  return BUY_LINK_US;
};

export const guessBuyLink = (): BuyLink => {
  const searchParams = new URLSearchParams(window.location.search);
  const lang = searchParams.get("lang");
  const buyLink = getBuyLink(lang);
  return buyLink;
};

export const Top = () => {
  const buyLink = guessBuyLink();

  return (
    <Box mx={4}>
      <Box
        display="flex"
        maxWidth={1140}
        flexDirection={{ xs: "column-reverse", sm: "row" }}
        marginLeft="auto"
        marginRight="auto"
      >
        <Box flex={1} mr={{ xs: 0, sm: 4 }} mt={{ xs: 2, sm: 0 }}>
          <Box mb={2} mt={2}>
            <Typography variant="h2">THE SCAEVOLA CONSPIRACY</Typography>
          </Box>
          <Box mb={2}>
            <Typography variant="h5" color="primary">
              Get ready for a high-octane thriller that will keep you on the
              edge of your seat!
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography variant="body1" color="textPrimary">
              Luke, an intellectually brilliant but socially awkward data
              scientist, lands a dream job at a prestigious Silicon Valley tech
              company. Teaming up with the sharp-tongued ex-hacker Ada and
              Clark, scion of a famous venture capitalist, their journey takes
              them into the heart of California's tech hub where artificial
              intelligence is about to change the world. But their lives take an
              unexpected turn when a string of mysterious deaths rocks the tech
              scene. Driven by the desire to make things right, they launch an
              investigation and discover a far-reaching conspiracy lurking
              beneath the glimmering surface of the Valley.
              <br /> <br />
              But time is running out! Can they prevent the upcoming apocalypse?
            </Typography>
          </Box>
          <Box display="flex">
            <Box mr={1} textAlign="center">
              <Link
                underline="none"
                href={buyLink.kindle}
                onClick={() => logEvent("buy-click-top-kindle")}
              >
                <AmazonImage src={amazon_dark} />
                <br />
                Buy for Kindle
              </Link>
            </Box>
            <Box ml={1} textAlign="center">
              <Link
                underline="none"
                href={buyLink.paper}
                onClick={() => logEvent("buy-click-top-paper")}
              >
                <AmazonImage src={amazon} />
                <br />
                Buy as paperback
              </Link>
            </Box>
          </Box>
        </Box>
        <Box flex={0} textAlign="center" mb={{ xs: 4, sm: 0 }}>
          <Image src={cover} />
        </Box>
      </Box>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./src/components/Top/Top.tsx